/**
 * Who may open the compliance patient outreach queue (/compliance-outreach), which calls
 * PUT patients/compliance/needs_contact.
 *
 * Matches the backend rule (S3DEV2-7674): the Administrator type, or an employee flagged
 * compliance_coach (S3_Employees.bComplianceCoach, returned at login), whatever their role.
 * ContractorAdministrator is an Administrator renamed at login, so it stays in. CompanyAdministrator,
 * OfficeAdministrator and their SaaS forms ServiceAdmin and ServiceCoach need the flag.
 *
 * Keep this and the backend's OutreachAccess.CanViewComplianceQueue in step: a role allowed here
 * but not there gets an empty table, and one allowed there but not here never sees the page.
 */
export const COMPLIANCE_OUTREACH_ROLES = ["Administrator", "ContractorAdministrator"];

export const canOpenComplianceOutreach = user =>
  COMPLIANCE_OUTREACH_ROLES.includes(user?.role) ||
  user?.compliance_coach === true;
